export default "__VITE_ASSET__DMCrjcnl__"